// extracted by mini-css-extract-plugin
export var formContainer = "_fi-0";
export var message = "_fi-1";